import client from '../../../api'
import type { RequestConfig, ResponseErrorConfig } from '../../../api'
import type {
  SchoolsControllerToggleAiTestMutationRequest,
  SchoolsControllerToggleAiTestMutationResponse,
  SchoolsControllerToggleAiTestPathParams,
} from '../../ts/schoolsDTO/SchoolsControllerToggleAiTest'

export function getSchoolsControllerToggleAiTestUrl({ schoolId }: { schoolId: SchoolsControllerToggleAiTestPathParams['schoolId'] }) {
  return `/schools/${schoolId}/toggle-ai-test` as const
}

/**
 * @summary Активация AI теста школы
 * {@link /schools/:schoolId/toggle-ai-test}
 */
export async function schoolsControllerToggleAiTest(
  { schoolId }: { schoolId: SchoolsControllerToggleAiTestPathParams['schoolId'] },
  data: SchoolsControllerToggleAiTestMutationRequest,
  config: Partial<RequestConfig<SchoolsControllerToggleAiTestMutationRequest>> & { client?: typeof client } = {},
) {
  const { client: request = client, ...requestConfig } = config

  const res = await request<SchoolsControllerToggleAiTestMutationResponse, ResponseErrorConfig<Error>, SchoolsControllerToggleAiTestMutationRequest>({
    method: 'PATCH',
    url: getSchoolsControllerToggleAiTestUrl({ schoolId }).toString(),
    data,
    ...requestConfig,
  })
  return res
}